export const getAuth = state => state.auth

export const getProfile = state => state.user.profile

export const getUnitSelected = state => state.unitSelected.data

export const getIdElement = state => state.unitSelected.idElement
